export default "__VITE_ASSET__DXoyc9f$__"